import { useEffect, useState, useRef, useMemo } from "react";
import axios from "../../../../axios";
import {
  errorToast,
  successToast,
  warningToast,
} from "../../../../utils/toast";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import Correct from "../../../../Images/check-button.png";
import Incorrect from "../../../../Images/cross.png";
import Skip from "../../../../Images/right-arrow.png";
import TimerImage from "../../../../Images/timeupimage.png";
import Loding from "../../../../componant/Loader/Loding";
import { useToast } from "@chakra-ui/react";
import { FaCircleCheck } from "react-icons/fa6";
import { FaShareAlt, FaPrint, FaDownload, FaCopy } from "react-icons/fa";
import Info from "../../../../Images/ph_info-duotone.png";
import { BsFillInfoCircleFill } from "react-icons/bs";
const QuestionPage = (props) => {
  const toast = useToast({ position: "top" });
  const [t, i18n] = useTranslation();
  const [loading, setLoading] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [data, setData] = useState({});
  const [nextdata, setNextdata] = useState({});
  const [userdata, setUserdata] = useState({});
  const [selectedOption, setSelectedOption] = useState(null);
  const [correctAnswers, setCorrectAnswers] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [timeLeft, setTimeLeft] = useState(30);
  const [showButton, setShowButton] = useState(false);
  const [showTimerButton, setShowTimerButton] = useState(false);
  const [correctAnswer, setCorrectAnswer] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [TimeOut, setIsTimeout] = useState(false);
  const timerRef = useRef(null);
  // const { data: user } = useUser();
  // console.log(user)

  const [completeData, setCompleteData] = useState({
    rightCount: 0,
    wrongCount: 0,
    skipCount: 0,
  });
  const fetchData = async () => {
    setLoading(true);
    setShowTimerButton(false);

    try {
      const response = await axios.get(`getUserQuestion`);
      if (response?.data) {
        setShowTimerButton(true);
        setData(response.data.result);
        console.log(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      fetchQuestions(i18n.language);
      // setTimerBasedOnQuesType(data.quesType);
      // setIsDisabled(false);
    }
  }, [data, i18n.language]);
  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setTimerBasedOnQuesType(data.quesType);
      setIsDisabled(false);
    }
  }, [data]);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      setShowButton(false);
      setIsTimeout(false);
      // setTimeLeft(30);
      startTimer();
    }
  }, [questions]);

  const setTimerBasedOnQuesType = (quesType) => {
    if (quesType === "gk") {
      setTimeLeft(40);
    } else if (quesType === "reasoning") {
      setTimeLeft(50);
    } else if (quesType === "maths") {
      setTimeLeft(60);
    }
  };

  const fetchQuestions = async (language) => {
    setLoading(true);
    try {
      const fetchedQuestions = {
        question: language !== "hi" ? data.question : data.questionHin,
        options: language !== "hi" ? data.options : data.optionsHin,
      };
      setQuestions([fetchedQuestions]);
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setIsSubmitted(false);
  };

  const handleSubmit = async () => {
    if (selectedOption === null) {
      toast({
        title: "Please select an option before submitting.",
        // description: "Thanks",
        status: "warning",
        duration: 4000,
        isClosable: true,
      });
      // warningToast("Please select an option before submitting.");
      return;
    }
    setShowTimerButton(false);
    const obj = {
      questionId: data._id,
      answer: selectedOption,
      type: "submit",
    };
    // setLoading(true);
    try {
      const res = await axios.post(`submitAnswer/`, obj);

      if (res) {
        setLoading(true);
        console.log(res?.data);
        const correctAnswer =
          i18n.language === "hi"
            ? res?.data.rightAnsHin
            : res?.data.rightAnsEng;
        setCorrectAnswer(correctAnswer);
        const isAnswerCorrect = selectedOption === correctAnswer;
        setIsCorrect(isAnswerCorrect);
        setIsSubmitted(true);

        if (isAnswerCorrect) {
          setCorrectAnswers(correctAnswers + 1);
          successToast(`Correct!`);
          toast({
            title: `Correct!`,
            // description: "Thanks",
            status: "success",
            duration: 4000,
            isClosable: true,
          });
        } else {
          toast({
            title: `Wrong!`,
            // description: "Thanks",
            status: "error",
            duration: 4000,
            isClosable: true,
          });
          // errorToast(`Incorrect. The correct answer is ${correctAnswer}.`);
        }

        setTimeout(() => {
          setSelectedOption(null);
          setLoading(false);
          setData(null);
          setShowTimerButton(true);
          axios.get(`getUserQuestion`).then((res) => {
            setData(res?.data?.result);
            setTimerBasedOnQuesType(res?.data?.result?.quesType);
          });
        }, 3000);

        // setLoading(false);
        // setShowButton(true);
        // setIsDisabled(true);
      }
    } catch (error) {
      console.error("Error submitting answer:", error);
    }
  };
  const handleSkip = async () => {
    setShowTimerButton(false);
    const obj = {
      questionId: data._id,

      type: "skip",
    };
    // setLoading(true);
    try {
      const res = await axios.post(`submitAnswer/`, obj);

      if (res) {
        setLoading(true);
        console.log(res?.data);
        const correctAnswer =
          i18n.language === "hi"
            ? res?.data.rightAnsHin
            : res?.data.rightAnsEng;
        setCorrectAnswer(correctAnswer);
        const isAnswerCorrect = selectedOption === correctAnswer;
        setIsCorrect(isAnswerCorrect);
        setIsSubmitted(true);

        if (isAnswerCorrect) {
          setCorrectAnswers(correctAnswers + 1);
          successToast(`Correct!`);
        } else {
          errorToast(`Incorrect.`);
        }

        setTimeout(() => {
          setSelectedOption(null);
          setLoading(false);
          setData(null);
          setShowTimerButton(true);
          axios.get(`getUserQuestion`).then((res) => {
            setData(res?.data?.result);
            setTimerBasedOnQuesType(res?.data?.result?.quesType);
          });
        }, 3000);

        // setLoading(false);
        // setShowButton(true);
        // setIsDisabled(true);
      }
    } catch (error) {
      console.error("Error submitting answer:", error);
    }
  };

  const handleNextQuestion = () => {
    setShowButton(false);
    setSelectedOption(null);
    setIsTimeout(false);
    fetchData();
    clearInterval(timerRef.current);
    // setTimeLeft(30); // Reset the timer for the next question
    startTimer();
  };

  const startTimer = () => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      setTimeLeft((prevTimeLeft) => {
        if (prevTimeLeft <= 1) {
          clearInterval(timerRef.current);
          setShowButton(true);
          setIsDisabled(true);
          setIsTimeout(true);
          return 0;
        }
        return prevTimeLeft - 1;
      });
    }, 1000);
  };

  useEffect(() => {
    if (Object.keys(userdata).length == 0) {
      axios
        .get("me")
        .then((response) => {
          setUserdata(response?.data?.result);
        })
        .catch((err) => {
          errorToast(err?.response?.data?.Comments);
        });
    }
  }, [userdata]);

  useEffect(() => {
    axios
      .get("me")
      .then((response) => {
        const userdata = response?.data?.result;
        setCompleteData({
          rightCount: userdata?.quizStats?.totalRight,
          wrongCount: userdata?.quizStats?.totalWrong,
          skipCount: userdata?.quizStats?.totalSkipped,
        });
      })
      .catch((err) => {
        errorToast(err?.response?.data?.Comments);
      });
  }, [data]);

  // const setCaptchaFunc = (data) => {
  //   if (extraTimeTimer) {
  //     clearTimeout(extraTimeTimer);
  //   }

  //   extraTimeTimer = setTimeout(() => {

  //     setCaptcha(data);

  //     timerRef?.current?.startTimer();
  //     setLoading(false);
  //   }, (userdata?.extraTime || 0) * 1000);

  // };

  const isDemoCompleted = useMemo(() => {
    if (
      userdata?.planName === "Test" &&
      userdata.rightCount + userdata.wrongCount + userdata.skipCount >= 100
    ) {
      return true;
    }
    return false;
  }, [userdata]);

  // console.log(userdata)
  // console.log(completeData)

  let totalEarning = Math.floor(userdata?.totalEarning);

  const generateOptionLabel = (index) => {
    return String.fromCharCode(65 + index);
  };
  const renderQuestion = () => {
    return (
      <>
        {loading ? (
          <div className="m-auto">
            <Loding />
          </div>
        ) : (
          <div className="">
            <h1 className="text-start text-2xl text-purple font-extrabold mb-4">
              Question :
            </h1>
            {questions[0] && (
              <h2 className="text-lg text-bgWhite text-start w-full font-semibold font-oswald">
                {questions[0]?.question}
              </h2>
            )}
            <br />
            <ul className="w-full text-white grid lg:grid-cols-2 lg:gap-4 gap-2">
              {questions[0]?.options?.map((option, index) => (
                <li
                  key={index}
                  className={`w-full flex justify-between items-center  border-2 hover:border-green mt-2 rounded-lg p-2 shadow-primary/10 border-purple transition hover:border-primary-focus/20 hover:shadow-primary-focus/20 transition duration-100 ease-in-out transform hover:-translate-y-1 hover:scale-105 ${
                    selectedOption === option && isSubmitted
                      ? isCorrect
                        ? "border-green-300 bg-green-600"
                        : "border-red-500 bg-red-600"
                      : "border-gray-500 cursor-pointer"
                  }`}
                  onClick={() =>
                    handleOptionChange({ target: { value: option } })
                  }
                >
                  <div className="flex items-center">
                    <span
                      className={`text-lg font-extrabold px-2 shadow-2xl bg-gray-200 rounded-lg ${
                        selectedOption === option
                          ? "text-green-500"
                          : "text-bgBlue"
                      }`}
                    >
                      {generateOptionLabel(index)}
                    </span>
                    <label
                      className="ml-5 cursor-pointer"
                      htmlFor={`option-${index}`}
                    >
                      {option}
                    </label>
                  </div>
                  {selectedOption === option && (
                    <span>
                      <FaCircleCheck
                        className="text-white text-"
                        size={20}
                        color="#44ca1b"
                        // backgroundColor="green-500"
                      />
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        )}
      </>
    );
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const [select, setSelect] = useState(timeLeft);
  const renderTime = ({ remainingTime }) => {
    if (remainingTime === 0) {
      return <div className="timer">Too late...</div>;
    }

    return (
      <div className="timer flex flex-col items-center font-montserrat">
        <div className="text text-gray-500">Remaining</div>
        <div className="value text-4xl text-black">{remainingTime}</div>
        <div className="text text-gray-500">seconds</div>
      </div>
    );
  };

  const [visibleTooltip, setVisibleTooltip] = useState(null);

  const showTooltip = () => {
    setVisibleTooltip(true);
  };

  const hideTooltip = () => {
    setVisibleTooltip(null);
  };

  return (
    <div className="w-full lg:py-14  py-3   h-screen  bg-bgBlue">
        <div className=" flex  gap-4 lg:px-2 px-2 justify-between lg:justify-between lg:ml-6 mb-4">
          <div className="flex gap-2 ">
            <div className="flex justify-center items-center gap-2">
              <div className="w-10 bg-green-600 rounded-full p-1 h-1 "></div>
              <h1 className="text-lg font-bold text-green">
                {completeData?.rightCount}
              </h1>
            </div>
            <div className="flex justify-center items-center gap-2">
              <div className="w-10 bg-redC rounded-full p-1 h-1 "></div>
              <h1 className="text-lg font-bold text-red">
                {completeData?.wrongCount}
              </h1>
            </div>
            <div className="flex justify-center items-center gap-2">
              <div className="w-10 bg-yellow-400 rounded-full p-1 h-1 "></div>
              <h1 className="text-lg font-bold text-yellow-500">
                {completeData?.skipCount}
              </h1>
            </div>
          </div>
          <div className="relative ">
            {/* <img className="text-white" src={Info} alt=""  onMouseEnter={() => showTooltip()}
              onMouseLeave={hideTooltip} /> */}
            <BsFillInfoCircleFill
              className="text-white "
              onMouseEnter={() => showTooltip()}
              onMouseLeave={hideTooltip}
              size={26}
            />
          </div>
          {visibleTooltip ? (
            <div
              role="tooltip"
              className="absolute z-10 lg:top-28 top-24 right-1 w-72 mt-1  text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-lg shadow-sm opacity-100 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-600"
            >
              <div className="p-2">
                {/* <div className="w-full  flex flex-col lg:justify-start justify-center  text-left ">
            <div className="lg:mt-2 text-start text-black ">
              <span className="text-primary text-xl">.</span>{" "}
              {t("Please Select Option Then Submit")}
            </div>
            <div className="  text-black ">
              <span className="text-primary text-xl">.</span>{" "}
              {t("There Have Negative Marking")}
            </div>
          </div> */}
                <ul
                  style={{ color: "#1C1A4A", listStyleType: "disc" }}
                  role="list "
                  className=" mb-4 text-left   text-bgBlue"
                >
                  <li className="flex items-center  justify-between p-1">
                    <div className="font-bold">
                      ⦿ {t("Please Select Option Then Submit")}
                    </div>
                  </li>

                  <li className="flex items-center  justify-between p-1">
                    <div className="font-bold">
                      ⦿ {t("There Have Negative Marking")}
                    </div>
                  </li>

                  <li className="flex items-center  justify-between p-1">
                    <div className="font-bold">
                      ⦿ {t("There Have Negative Marking")}
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          ) : null}
        </div>
      <div
        className={
          " relative  rounded-xl m-auto   font-sans bg-bgBlue  h-full gap-1 p-4"
        }
      >
      

        <div
          className={
            " flex flex-col  m-auto  sm:my-0 font-sans bg-bgBlue lg:p-4 lg:px-8   gap-1"
          }
        >
          <div className=" flex lg:flex-row flex-col w-full ">
            <div className="lg:w-2/3 lg:-order-1 order-2">
              {data ? (
                <div className="m-auto">{renderQuestion()}</div>
              ) : (
                <p>Loading questions...</p>
              )}
            </div>
            <div className="lg:order-2 order-1 m-auto">
              <div className="flex justify-center items-center m-auto ">
                <div className="m-auto">
                  {TimeOut ? (
                    <div className="lg:w-40 w-32 lg:mt-8">
                      <img src={TimerImage} alt="" />
                    </div>
                  ) : //   <h1 className="rounded-full px-6 text-center py-2 font-bold text-xl text-redC  ">
                  //   Time Out
                  // </h1>

                  showTimerButton ? (
                    // <div className="relative m-auto">
                    //   <img src={TimerImage} alt="" className="lg:w-2/3 w-1/2 m-auto" />
                    //   <h1 className="absolute lg:top-12 top-8 left-20  lg:text-lg text-sm font-extrabold text-bgBlue lg:ml-1
                    //   ml-2 lg:mt-1 mt-2">
                    //     {`${timeLeft} S`}
                    //   </h1>
                    // </div>

                    //     <div className="flex justify-center items-center ">
                    //     <div className="relative w-24 h-24 lg:w-36 lg:h-36 flex justify-center items-center">

                    //       <div className="absolute w-full h-full rounded-full bg-gray-300"></div>

                    //       <div className="absolute w-[88%] h-[88%] rounded-full bg-orange-500 flex justify-center items-center">

                    //         <div className="w-[60%] h-[60%] rounded-full bg-white flex justify-center items-center">
                    //         <CountdownCircleTimer
                    //     key={timer}
                    //    isPlaying
                    //    duration={select}
                    //    colors={[["#004777", 0.33], ["#F7B801", 0.33], ["#A30000"]]}
                    //    onComplete={() => [false, 1000]}
                    //  >
                    //    {renderTime}
                    //  </CountdownCircleTimer>
                    //         </div>
                    //       </div>
                    //     </div>
                    //   </div>
                    <div className="flex justify-center items-center lg:mt-20 ">
                      <div className="relative w-24 h-24 lg:w-36 lg:h-36 flex justify-center items-center">
                        <div className="absolute w-full h-full rounded-full bg-gray-300"></div>

                        <div className="absolute w-[88%] h-[88%] rounded-full bg-purple flex justify-center items-center">
                          <div className="w-[60%] h-[60%] rounded-full bg-white flex justify-center items-center p-1">
                            <CircularProgressbar
                              value={(timeLeft / 60) * 100}
                              text={`${timeLeft} s`}
                              styles={buildStyles({
                                rotation: 0,
                                strokeLinecap: "butt",
                                textSize: "30px",
                                pathTransition: "none",
                                pathColor:
                                  timeLeft <= 10
                                    ? "rgba(255, 0, 0, 1)"
                                    : timeLeft <= 20
                                    ? "rgba(255, 255, 153, 1)"
                                    : "rgba(36, 145, 42, 1)",
                                textColor: "#4D2C5E",
                                trailColor: "#fff",
                                backgroundColor: "#fff",
                                text: {
                                  fontWeight: "600",
                                },
                              })}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <h1 className="rounded-full px-6 text-center py-2 font-bold text-xl text-green  ">
                      Please Wait.....
                    </h1>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="float-right w-auto content-center px-3 mr-2   items-center mt-4">
            {
              showButton ? (
                <button
                  onClick={handleNextQuestion}
                  className="rounded-full px-6 text-center py-2 font-poppinsbold text-15 text-white border bg-purple hover:bg-brightYellow  shadow-lg"
                >
                  Next Question
                </button>
              ) : showTimerButton ? (
                <button className="rounded-full px-6 text-center py-2 font-poppinsbold text-15 text-white bg-redC  shadow-lg">
                  {`${timeLeft}-S`}
                </button>
              ) : (
                <h1 className="rounded-full px-6 text-center py-2 font-poppinsbold text-15 text-green  shadow-lg">
                  Please Wait.....
                </h1>
              )

           
            }
          </div> */}
          <div className="flex lg:flex-col-2 lg:gap-20 gap-10 lg:my-10 my-5 items-center justify-center lg:justify-start">
            {showButton ? (
              <button
                onClick={handleNextQuestion}
                className="rounded-full px-6 text-center py-2 font-bold text-15 text-white  bg-purple hover:bg-brightYellow  shadow-[4px_4px_#A695AE]"
              >
                Next Question
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                className={`rounded-full px-8 text-center py-2 font-bold text-15 text-white  bg-purple hover:bg-brightYellow  shadow-[4px_4px_#A695AE] ${
                  isDisabled ? "bg-gray-400 cursor-not-allowed" : ""
                }`}
                type="submit"
                form="form"
                disabled={isDisabled}
              >
                {t("Submit")}
              </button>
            )}

            <button
              onClick={handleSkip}
              disabled={isDisabled}
              className={`rounded-full px-8 text-center py-2 font-bold hover:text-white text-15 text-purple   bg-white hover:bg-brightYellow shadow-[4px_4px_#A695AE]  ${
                isDisabled ? "bg-gray-400 cursor-not-allowed" : ""
              }`}
            >
              Skip
            </button>
          </div>
          <div className="flex flex-col-5 lg:gap-5 gap-2 text-13 items-center  "></div>

          {/* <div className="w-full  flex flex-col lg:items-start lg:justify-start justify-center items-center text-left ">
            <div className="lg:mt-8 text-start text-coolGray text-9 lg:text-sm">
              <span className="text-primary text-40">.</span>{" "}
              {t("Please Select Option Then Submit")}
            </div>
            <div className=" text-center text-coolGray text-9 lg:text-sm">
              <span className="text-primary text-40">.</span>{" "}
              {t("There Have Negative Marking")}
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default QuestionPage;
